/** 1 … 4 5 [6] 7 8 … 63 — luôn có trang đầu/cuối và 2 trang quanh trang hiện tại */
function pageItems(page: number, total: number): (number | 'gap')[] {
  const near = new Set([1, total])
  for (let p = page - 1; p <= page + 1; p++) near.add(p)
  if (page <= 3) [2, 3, 4].forEach((p) => near.add(p))
  if (page >= total - 2) [total - 3, total - 2, total - 1].forEach((p) => near.add(p))
  const pages = [...near].filter((p) => p >= 1 && p <= total).sort((a, b) => a - b)
  const out: (number | 'gap')[] = []
  for (const p of pages) {
    const prev = out[out.length - 1]
    if (typeof prev === 'number' && p - prev === 2) out.push(prev + 1)
    else if (typeof prev === 'number' && p - prev > 2) out.push('gap')
    out.push(p)
  }
  return out
}

export function Pager({ page, totalPages, onPage }: { page: number; totalPages: number; onPage: (p: number) => void }) {
  if (totalPages <= 1) return null
  return (
    <nav className="pager" aria-label="Phân trang">
      <button type="button" className="pager-btn" disabled={page <= 1} onClick={() => onPage(page - 1)} aria-label="Trang trước">
        <i className="fa-solid fa-chevron-left" aria-hidden />
      </button>
      {pageItems(page, totalPages).map((p, i) =>
        p === 'gap' ? (
          <span key={`gap-${i}`} className="pager-gap">
            …
          </span>
        ) : (
          <button
            key={p}
            type="button"
            className={`pager-btn${p === page ? ' active' : ''}`}
            aria-current={p === page ? 'page' : undefined}
            onClick={() => onPage(p)}
          >
            {p}
          </button>
        ),
      )}
      <button
        type="button"
        className="pager-btn"
        disabled={page >= totalPages}
        onClick={() => onPage(page + 1)}
        aria-label="Trang sau"
      >
        <i className="fa-solid fa-chevron-right" aria-hidden />
      </button>
    </nav>
  )
}
